module.exports = "<mat-toolbar color=\"primary\">\n    <h6>© 2020 Michala Vacíková <app-year-pipe></app-year-pipe></h6>\n</mat-toolbar> "